module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4r3n1n2r-e67bda0d91e012e931e3519996d04ab6.svg";